export const RetrySVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Left icon">
        <path
          id="icon"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1126 2.6323C11.9148 2.13987 9.61392 2.43584 7.61233 3.46844C5.61073 4.50103 4.03592 6.20451 3.16337 8.28087C2.29082 10.3572 2.17608 12.6743 2.83924 14.8267C3.5024 16.9791 4.90123 18.8298 6.79102 20.0551C8.68081 21.2804 10.9412 21.8022 13.1769 21.5293C15.4126 21.2564 17.4811 20.2061 19.0206 18.5622C20.5602 16.9183 21.4727 14.7855 21.5987 12.5367C21.6172 12.2059 21.364 11.9227 21.0331 11.9041C20.7023 11.8856 20.4191 12.1388 20.4005 12.4696C20.2904 14.4373 19.4919 16.3035 18.1448 17.742C16.7977 19.1804 14.9877 20.0994 13.0315 20.3381C11.0753 20.5769 9.09742 20.1203 7.44385 19.0482C5.79029 17.9761 4.56631 16.3567 3.98605 14.4734C3.40578 12.59 3.50617 10.5626 4.26966 8.74577C5.03314 6.92895 6.4111 5.43841 8.16249 4.53489C9.91389 3.63137 11.9272 3.37239 13.8502 3.80327C15.4489 4.16148 16.9006 4.9775 18.0334 6.14145L16.4872 6.14474C16.1558 6.14544 15.8878 6.41464 15.8885 6.74601C15.8892 7.07738 16.1584 7.34544 16.4897 7.34473L19.3182 7.33872C19.6495 7.33801 19.9176 7.06881 19.9169 6.73744L19.9109 3.90902C19.9102 3.57765 19.641 3.30959 19.3096 3.3103C18.9782 3.311 18.7102 3.5802 18.7109 3.91157L18.7135 5.12448C17.4466 3.89006 15.8561 3.02296 14.1126 2.6323Z"
          fill="#27AE60"
        />
      </g>
    </svg>
  );
};
